Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "GroupInfo3390947453",
  {"root":"GroupInfo3390947453--root","wrapper":"GroupInfo3390947453--wrapper","createdByRow":"GroupInfo3390947453--createdByRow","chatIcon":"GroupInfo3390947453--chatIcon","row":"GroupInfo3390947453--row","groupTypeIcon":"GroupInfo3390947453--groupTypeIcon"},
  "",
  12,
  "GroupInfo3390947453"
);

